<template>
  <div class="main-wrapper">
    <!---Navigation-->
    <Navbar
      :topbarColor="topbarColor"
      :logo="require('@/assets/images/logo/logo-light-icon.png')"
      :title="logotitle"
    />
    <!---Sidebar-->
    <SideBar parent=".main-wrapper" :sidebarLinks="sidebarLinks" />
    <!---Page Container-->
    <div class="main-container-fluid">
      <div
        v-if="alert.message"
        :key="Math.random()"
        :class="'text-center alert ' + alert.type"
      >
        {{ alert.message }}
      </div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Navbar from "@/views/user/layout/header/Navbar.vue";
import SideBar from "@/views/user/layout/sidebar/SideBar.vue";
import sidebarLinks from "@/views/user/layout/sidebar/sidebarlinks.js";
import { mapState, mapActions } from "vuex";

export default {
  name: "MainContainer",
  components: {
    Navbar,
    SideBar
  },
  data: () => ({
    // topbarColor: "#95c720",
    topbarColor: "#000000",
    logotitle: "Quickleap",
    sidebarLinks: sidebarLinks
  }),
  created() {
    // reset login status
    this.clearAlert();
  },
  computed: {
    ...mapState({
      alert: state => state.alert
    })
  },
  methods: {
    ...mapActions({
      clearAlert: "alert/clear"
    })
  },
  watch: {
    $route(to, from) {
      // clear alert on location change
      this.clearAlert();
    }
  }
};
</script>
